<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editForm" ref="editForm" label-width="170px">
        <el-form-item class="addAdminForm" label="入库类别">
          <el-select v-model="editForm.zilei" placeholder="请选择">
            <el-option label="生产领用出库" value="201"></el-option>
            <el-option label="退货出库" value="202"></el-option>
            <el-option label="返修完成出库" value="203"></el-option>
            <el-option label="其他出库" value="204"></el-option>
            <el-option label="样品出库" value="205"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="商品名称">
          <el-input v-model="editForm.shangpinname" disabled></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="商品编码">
          <el-input v-model="editForm.shangpincode" disabled></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="日期">
          <el-date-picker v-model="editForm.riqi" type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item class="addAdminForm" label="数量">
          <el-input v-model="editForm.num"></el-input>
        </el-form-item>
        <el-form-item label="客户" class="addAdminForm">
          <el-input v-model="editForm.customername"></el-input>
        </el-form-item>
        <el-form-item label="备注(选填)" class="addAdminForm">
          <el-input v-model="editForm.beizhu"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickSave">保存</el-button>
          <el-button type="info" @click="clickReturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      editForm: {
        id: 0,
        zilei: '',
        shangpinname: '',
        shangpincode: '',
        riqi: '',
        num: '',
        customername: '',
        beizhu: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.editForm.id = row.Id
      this.editForm.zilei = row.Zilei.toString()
      this.editForm.shangpinname = row.Shangpinname
      this.editForm.shangpincode = row.Shangpincode
      this.editForm.riqi = row.Riqi
      this.editForm.num = row.Num
      this.editForm.beizhu = row.Beizhu
      this.editForm.customername = row.Customername
    },
    clickReturn () {
      this.$emit('triggerFunc', '')
    },
    clickSave () {
      this.apiEditErp6InventoryOut()
    },
    apiEditErp6InventoryOut: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editForm.id,
        zilei: that.editForm.zilei,
        riqi: that.editForm.riqi,
        num: that.editForm.num,
        customername: that.editForm.customername,
        beizhu: that.editForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditErp6InventoryOut, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
